/**
 * @module FE-CU56_利用規約画面
 */
import TermView from '../../components/termView/TermView.vue';
import Header from '../../components/header/Header.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';

const PAGE_ID = 'FE-CU56';

export default {
  name: 'Terms',
  components: {
    TermView,
    Header,
    BreadCrumbList,
    PcPageTitle,
    PCFooter,
    MobileFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU56利用規約画面.利用規約'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU56利用規約画面.C0001'),
      htmlContent: '',
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU56利用規約画面.利用規約'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU56利用規約画面.C0001'),
      };
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    this.loadHtml(this.$vuetify.lang.current);
  },
  /** @type {Methods} */
  methods: {
    /**
     * 静的ページの読み込み
     * @param {String} lang 表示言語
     */
    loadHtml(lang) {
      var htmlPath = '';
      htmlPath =
        lang === 'ja'
          ? window.location.origin + '/hs-static/service-agreement-jpn.html'
          : window.location.origin + '/hs-static/service-agreement-eng.html';

      fetch(htmlPath).then((res) => {
        res.text().then((html) => {
          this.htmlContent = html;
        });
      });
    },
    /**
     * 表示言語切り替え
     * @param {String} lang 表示言語
     */
    changeLang(lang) {
      this.loadHtml(lang);
    },
  },
};
